import { api } from '@/config/api';

export type ActivityKind =
  | 'whatsapp_in' | 'whatsapp_out'
  | 'email_in' | 'email_out'
  | 'sms_in' | 'sms_out'
  | 'call_in' | 'call_out'
  | 'note'
  | 'meeting'
  | 'task_created' | 'task_completed'
  | 'deal_created' | 'deal_stage_change' | 'deal_won' | 'deal_lost'
  | 'lead_received' | 'lead_assigned'
  | 'system';

export type ActivityEntityType = 'contact' | 'deal' | 'lead';

export interface Activity {
  _id: string;
  activityUid: string;
  companyUid: string;
  entityType: ActivityEntityType;
  entityUid: string;
  kind: ActivityKind;
  actorUserUid?: string;
  actorKind: 'user' | 'system' | 'bot';
  payload: Record<string, unknown>;
  summary?: string;
  createdAt: string;
}

const BASE = '/slighter_crm/activities';

export const activitiesService = {
  timeline: async (entityType: ActivityEntityType, entityUid: string, params?: { limit?: number; before?: string }): Promise<Activity[]> =>
    (await api.get(`${BASE}/${entityType}/${entityUid}`, { params })).data,
};
